import "./src/styles/global.css"

// Tell Google Tag Manager about client-side page changes, as
// gatsby-plugin-google-tagmanager did before it was replaced.
export const onRouteUpdate = () => {
  if (process.env.NODE_ENV !== "production") return
  // Wait a moment so the new page title is in place.
  setTimeout(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: "gatsby-route-change" })
  }, 50)
}
